import { NotificationsView } from "../ws7/notifications/NotificationsView";
import "../ws7/ws7.css";

/** /notifications?unread=1 (WS7). */
export function NotificationsPage() {
  return <NotificationsView />;
}
